// extracted by mini-css-extract-plugin
export default {"cardgroupGrid":"CardGroupPage_cardgroupGrid__C0amF"};